const tabsSchema = {
	group: "block",
	content: "tab+",
	defining: true,
	attrs: {
		childAttrs: { default: [] },
	},
};

export default tabsSchema;
